import React from 'react';
import { AppStore } from 'reducers';
import { RouterLocation } from 'router';
import NoOffersErrorPage from 'components/ErrorPage/NoOffersErrorPage';
import { TOfferPurchasable } from 'views/Checkout/types';
import { useGetAvailableOfferQuery } from 'views/Checkout/offer.generated';
import { getPaymentMethod } from 'actions/billing';
import Checkout from './Checkout';

interface ICheckoutViewProps {
  location: RouterLocation;
}

type TCheckoutViewLocationQuery = {
  createAccount?: boolean;
  packageId?: string;
  promoCode?: string;
  redirectTo?: string;
};

function CheckoutView({ location }: ICheckoutViewProps) {
  const {
    createAccount,
    promoCode,
    redirectTo,
  }: TCheckoutViewLocationQuery = location.query || {};

  const packageId = (location?.params?.id || location?.query?.packageId || '') as string;

  const {
    data,
    loading,
    error: apolloError,
  } = useGetAvailableOfferQuery({
    variables: {
      offerId: packageId,
    },
  });

  if (loading) return null;

  const { offer, entitlements } = data?.viewer || {};
  const isOfferBought = entitlements?.edges?.some(e => e?.node.offerId === packageId);

  if (!offer || isOfferBought || apolloError) {
    return <NoOffersErrorPage hasEntitlement={!!entitlements?.edges?.length} />;
  }

  return (
    <Checkout
      createAccount={createAccount}
      packageId={packageId}
      promoCode={promoCode}
      offer={offer as TOfferPurchasable}
      redirectTo={redirectTo}
    />
  );
}

export const initCheckoutConfirmation = (store: AppStore): Promise<void> => (
  store.dispatch(getPaymentMethod())
);

export default React.memo(CheckoutView);
